var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7901 18.1854H33.7096C30.2863 18.1854 27.5 15.3991 27.5 11.9758C27.5 8.55255 30.2863 5.76621 33.7096 5.76621C34.0494 5.76621 34.3873 5.79378 34.721 5.84874C35.9576 2.62779 39.0766 0.443726 42.5805 0.443726C46.1226 0.443726 49.3082 2.70677 50.5032 6.00764C53.1379 6.76174 54.9999 9.19133 54.9999 11.976C54.9997 15.3991 52.2134 18.1854 48.7901 18.1854Z",
    fill: "#F9BA48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7432 29.4276C50.6411 27.876 47.1672 27.0563 43.6987 27.0563H32.5133L22.4598 19.9596H13.8275L20.9242 27.0563H13.6447L5.66092 19.9596H0.410156L3.92489 27.8689L2.66259 28.0792V31.0608L3.22947 31.4662C7.31536 34.3848 12.1296 35.9274 17.1507 35.9274H19.1502L12.6593 42.4181L13.5659 43.0169C13.8489 43.2041 14.1159 43.4196 14.359 43.6573L14.6179 43.9111H19.7994L31.1098 35.9272H43.4759C46.5355 35.9272 49.5126 35.316 52.3237 34.1113L53.6223 33.555C54.4597 33.1949 55.0009 32.3743 55.0009 31.4632C55.0011 30.5958 54.5193 29.816 53.7432 29.4276ZM18.1103 21.7338H21.8974L29.4376 27.0563H23.433L18.1103 21.7338ZM3.1406 21.7338H4.98674L10.9746 27.0563H9.75315C9.11976 27.0563 8.4819 27.1096 7.85746 27.2133L5.73283 27.5673L3.1406 21.7338ZM52.9236 31.9239L51.6249 32.4801C49.0346 33.5908 46.2944 34.1532 43.4761 34.1532H33.6232L35.11 33.1038L34.0863 31.6543L19.2364 42.137H15.4491L24.5799 33.0062L23.3257 31.7519L20.9244 34.1532H17.1505C12.5739 34.1532 8.18291 32.7685 4.43662 30.147V29.582L8.14919 28.9628C8.67788 28.875 9.21812 28.8305 9.75315 28.8305H43.6987C46.8939 28.8305 50.0929 29.5854 52.9493 31.0137C53.1205 31.0997 53.2268 31.2719 53.2268 31.4634C53.2268 31.6638 53.1071 31.8449 52.9236 31.9239Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9676 54.5562H5.32248C2.38712 54.5562 0 52.1691 0 49.2337C0 46.6275 1.91878 44.4204 4.45419 44.0025C5.7014 41.776 8.0779 40.3628 10.6452 40.3628C14.0179 40.3628 16.9064 42.7482 17.5858 45.9994C19.2713 46.6568 20.4032 48.2747 20.4032 50.1208C20.4032 52.5664 18.4134 54.5562 15.9676 54.5562Z",
    fill: "#F9BA48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.902 45.6853H30.1602V47.4595H47.902V45.6853Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3875 45.6853H26.6133V47.4595H28.3875V45.6853Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1778 6.65308H7.98438V8.4273H22.1778V6.65308Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21172 6.65308H4.4375V8.4273H6.21172V6.65308Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.744 11.0887H4.4375V12.863H17.744V11.0887Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66094 11.0887H0.886719V12.863H2.66094V11.0887Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_1055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.cdf63402b8383f2f0daceca062531ae7.svg";
export { ForwardRef as ReactComponent };